// import Promise from 'pinkie-promise';
import UBT from '@/utils/ubt';
import { scriptJs } from '@/utils/crossOriginInstruments';
import params from '../param.js';
import Storage from '../storage';
import appConst from '../../const/app.const';
import toast from '../../components/toast/store';
import commonService from '../../service/commonService.js';
import env from '../env.js';

const APP_ID = appConst.hitchWxAppId;


let payLocked = false;

let loadPromise;
function loadJSSDKScript() {
  if (loadPromise) {
    return loadPromise;
  }
  loadPromise = new Promise((resolve, reject) => {
    scriptJs(
      'https://m.hellobike.com/resource/gallery/399/ym1qxTMq_jweixin-1.6.0.js',
      () => {
        if (window.wx) {
          resolve(window.wx);
        } else {
          UBT.sendError({ keyword: 'load_wx_jssdk_failed' });
          reject(new Error('加载微信jssdk失败'));
        }
      }, null, true,
    );
  });
  return loadPromise;
}

let configPromise;
function configWeixin() {
  if (!env.isWeixin) {
    return Promise.reject(new Error('not weixin'));
  }
  if (configPromise && window.wx && window.wx.appId === APP_ID) {
    return configPromise;
  }
  configPromise = loadJSSDKScript().then(
    (wx) => new Promise((resolve, reject) => {
      const loc = window.top.location;
      const url = loc.origin + loc.pathname + loc.search;
      // const url = 'https://m.hellobike.com/AppHelloBikeHitchH5/uat/latest/index.html';
      commonService.getWeixinSign(url).then(
        (response) => {
          const responseData = response.data;
          wx.config({
            debug: false,
            appId: window.wx.appId || APP_ID,
            timestamp: responseData.timestamp,
            nonceStr: responseData.nonceStr,
            signature: responseData.signature,
            jsApiList: [
              'onMenuShareTimeline',
              'onMenuShareAppMessage',
              'onMenuShareQQ',
              'onMenuShareWeibo',
              'onMenuShareQZone',
              'hideMenuItems',
              'showMenuItems',
              'hideAllNonBaseMenuItem',
              'showAllNonBaseMenuItem',
              'getLocation',
              'openLocation',
              'closeWindow',
              'scanQRCode',
              'chooseImage',
              'getLocalImgData',
            ],
            openTagList: [
              'wx-open-launch-weapp',
              'wx-open-launch-app',
            ],
          });
        },
        () => {
          toast.showToast('获取微信签名失败');
          reject(new Error('获取微信签名失败'));
        },
      );

      wx.ready(() => {
        resolve(wx);
      });

      wx.error((res) => {
        // eslint-disable-next-line no-console
        console.warn('config weixin failed', res);
        UBT.sendError({
          keyword: 'config_wechat_failed',
          wxerror: JSON.stringify(res),
        });
        reject(new Error(`配置微信异常, ${res.errMsg}`));
      });
    }),
  );

  return configPromise;
}

function bindWXMethod(methodName) {
  return (...args) => configWeixin().then((wx) => {
    wx[methodName](...args);
  });
}

function handleMiniProRoute(callFuncName, url) {
  try {
    return new Promise((resolve, reject) => {
      configWeixin().then((wx) => {
        wx.miniProgram.getEnv((res) => {
          if (res.miniprogram) {
            wx.miniProgram[callFuncName]({
              url,
              success: resolve,
              fail: reject,
            });
          } else {
            reject();
          }
        });
      });
    });
  } catch (e) {
    return Promise.reject(e);
  }
}

const wechat = {
  appId: APP_ID,

  loadJSSDKScript,

  config() {
    return configWeixin();
  },

  redirectToGetCode(backUrl, scope) {
    const url = 'https://m.ttbike.com.cn/weiAuthrize/index.html';
    const encodedBackUrl = encodeURIComponent(backUrl);
    const redirectUri = `${url}?appid=${APP_ID}&redirect_uri=${encodedBackUrl}&response_type=code&scope=${scope}`;
    window.location.replace(redirectUri);
  },

  getWexinUserInfo() {
    const scope = 'snsapi_userinfo';
    // const timerId = setTimeout(() => {
    //   toast.showToast('请稍候...', {
    //     className: 'validate-wx-toast',
    //   });
    // }, 500);

    const promise = new Promise((resolve) => {
      const refreshToken = Storage.getItem('wx_refresh_access_token');
      resolve(refreshToken || null);
    }).then((refreshToken) => {
      if (!refreshToken) {
        let chances = Number(Storage.getItem('accesstoken_chances') || 1);
        chances += 1;
        if (chances >= 4) {
          Storage.removeItem('accesstoken_chances');
          UBT.sendError({ keyword: 'get_wechat_accesstoken_failed' });
          throw new Error(
            `连续获取accesstoken${chances - 1}次失败, 请关闭页面重试`,
          );
        }
        Storage.setItem('accesstoken_chances', chances);
        const code = wechat.getCode(window.location.href);

        if (!code) {
          wechat.redirectToGetCode(window.location.href, scope);
          const error = new Error('未获取到code, 系统引导去获取code');
          error.cancelPromiseChain = true;
          throw error;
        } else {
          return commonService
            .getWeixinUserInfo({ wechatCode: code })
            .then((data) => {
              Storage.removeItem('accesstoken_chances');
              return data;
            })
            .catch((errorCode) => {
              if (errorCode === 666) {
                Storage.removeItem('wx_refresh_access_token');
                this.getWexinUserInfo();
              }
            });
        }
      } else {
        return commonService
          .getWeixinUserInfo({ wechatRefreshToken: refreshToken })
          .then((data) => {
            Storage.removeItem('accesstoken_chances');
            return data;
          })
          .catch((code) => {
            if (code === 666) {
              Storage.removeItem('wx_refresh_access_token');
              this.getWexinUserInfo();
            }
          });
      }
    });

    return new Promise((resolve, reject) => {
      promise.then(resolve, (error) => {
        // 吃掉cancelPromiseChian的error
        if (!error.cancelPromiseChain) {
          reject(error);
        }
      });
    });
  },

  getOpenId({ scope = 'snsapi_base', validate = true } = {}) {
    const timerId = setTimeout(() => {
      toast.showToast('请稍候...', {
        className: 'validate-wx-toast',
      });
    }, 500);
    const promise = new Promise((resolve, reject) => {
      const storageOpenId = Storage.getItem(`${scope}wx_open_id_`);
      if (storageOpenId) {
        if (validate) {
          commonService.validateOpenId(storageOpenId).then((valid) => {
            if (valid) {
              resolve(storageOpenId);
            } else {
              resolve(null);
            }
          }, reject);
        } else {
          resolve(storageOpenId);
        }
      } else {
        resolve(null);
      }
    }).then((openId) => {
      if (!openId) {
        let chances = Number(Storage.getItem('chances') || 1);
        chances += 1;
        if (chances >= 4) {
          Storage.removeItem('chances');
          UBT.sendError({ keyword: 'get_wechat_openid_failed' });
          throw new Error(`连续获取openId${chances - 1}次失败, 请关闭页面重试`);
        }
        Storage.setItem('chances', chances);
        const code = wechat.getCode(window.location.href);
        if (!code) {
          wechat.redirectToGetCode(window.location.href, scope);
          const error = new Error('未获取到code, 系统引导去获取code');
          error.cancelPromiseChain = true;
          throw error;
        } else {
          return commonService
            .getWeixinOpenId(code, scope)
            .then((wxOpenId) => {
              Storage.removeItem('chances');
              return wxOpenId;
            })
            .catch(() => this.getOpenId({ scope, validate }));
        }
      }
      Storage.removeItem('chances');
      return openId;
    });

    return new Promise((resolve, reject) => {
      promise
        .then(resolve, (error) => {
          // 吃掉cancelPromiseChian的error
          if (!error.cancelPromiseChain) {
            reject(error);
          }
        })
        .then(() => {
          clearTimeout(timerId);
          toast.clearToasts('.validate-wx-toast');
        });
    });
  },

  /**
   * 参考获取openId
   * 1. 先从storage读取refreshtoken
   * 2. 有refreshtoken直接调用接口获取
   * 3. 没有refreshtoken走授权获取code调用接口
   */
  getAccessToken() {
    const scope = 'snsapi_userinfo';
    const timerId = setTimeout(() => {
      toast.showToast('请稍候...', {
        className: 'validate-wx-toast',
      });
    }, 500);

    const promise = new Promise((resolve) => {
      const refreshToken = Storage.getItem('wx_refresh_access_token');
      resolve(refreshToken || null);
    }).then((refreshToken) => {
      if (!refreshToken) {
        let chances = Number(Storage.getItem('accesstoken_chances') || 1);
        chances += 1;
        if (chances >= 4) {
          Storage.removeItem('accesstoken_chances');
          UBT.sendError({ keyword: 'get_wechat_accesstoken_failed' });
          throw new Error(
            `连续获取accesstoken${chances - 1}次失败, 请关闭页面重试`,
          );
        }
        Storage.setItem('accesstoken_chances', chances);
        const code = wechat.getCode(window.location.href);

        if (!code) {
          wechat.redirectToGetCode(window.location.href, scope);
          const error = new Error('未获取到code, 系统引导去获取code');
          error.cancelPromiseChain = true;
          throw error;
        } else {
          return commonService
            .getAccessToken({ wechatCode: code })
            .then((data) => {
              Storage.removeItem('accesstoken_chances');
              return data;
            })
            .catch((errorCode) => {
              if (errorCode === 666) {
                Storage.removeItem('wx_refresh_access_token');
                this.getAccessToken();
              }
            });
        }
      } else {
        return commonService
          .getAccessToken({ wxRefreshToken: refreshToken })
          .then((data) => {
            Storage.removeItem('accesstoken_chances');
            return data;
          })
          .catch((code) => {
            // refeshtoken 过期 移除缓存
            if (code === 666) {
              Storage.removeItem('wx_refresh_access_token');
              this.getAccessToken();
            }
          });
      }
    });

    return new Promise((resolve, reject) => {
      promise
        .then(resolve, (error) => {
          // 吃掉cancelPromiseChian的error
          if (!error.cancelPromiseChain) {
            reject(error);
          }
        })
        .then(() => {
          clearTimeout(timerId);
          toast.clearToasts('.validate-wx-toast');
        });
    });
  },

  // 获取用户微信code
  getCode() {
    if (!this.wxCode) {
      const code = params.get('code');
      this.wxCode = code;
    }
    return this.wxCode;
  },

  // 调用微信支付
  pay(
    options = {
      timestamp: null,
      nonceStr: null,
      package: null,
      paySign: null,
    },
  ) {
    if (!env.isWeixin) {
      return Promise.reject(new Error('不在微信环境下'));
    }

    if (payLocked) {
      return Promise.reject(new Error('存在尚未完成的支付调用'));
    }
    payLocked = true;
    return new Promise((resolve, reject) => {
      configWeixin().then(
        (wx) => {
          const payParams = {
            appId: APP_ID,
            signType: 'MD5',
            success() {
              resolve();
              payLocked = false;
            },
            cancel() {
              reject();
              payLocked = false;
            },
            fail() {
              reject(new Error('微信闹情绪了'));
              payLocked = false;
              UBT.sendError({ keyword: 'wechat_pay_failed' });
            },
            ...options,
          };

          wx.chooseWXPay(payParams);
        },
        (...args) => {
          // eslint-disable-next-line
          reject(...args);
          payLocked = false;
        },
      );
    });
  },

  scanQRCode(options) {
    return configWeixin().then(
      (wx) => new Promise((resolve, reject) => {
        const scanOptions = {
          scanType: ['qrCode'],
          needResult: 1,
          success(res) {
            resolve(res && res.resultStr);
          },
          cancel() {
            reject();
          },
          fail() {
            reject(new Error('扫码失败'));
          },
          ...options,
        };
        wx.scanQRCode(scanOptions);
      }),
    );
  },

  chooseImage(options) {
    return configWeixin().then(
      (wx) => new Promise((resolve, reject) => {
        wx.chooseImage(
          {
            count: 1, // 默认9
            sizeType: ['original', 'compressed'],
            sourceType: ['album', 'camera'],
            success(res) {
              resolve(res.localIds);
            },
            cancel() {
              reject();
            },
            fail() {
              reject(new Error('照片选择失败'));
            },
            ...options,
          },
        );
      }),
    );
  },

  // 获取gps坐标
  getLocation() {
    return configWeixin().then(
      (wx) => new Promise((resolve) => {
        wx.getLocation({
          type: 'wgs84',
          success(res) {
            resolve(res);
          },
        });
      }),
    );
  },
  openLocation(param) {
    return configWeixin().then(
      (wx) => new Promise(() => {
        wx.openLocation({
          ...param,
          latitude: +param.latitude, // 纬度，浮点数，范围为90 ~ -90
          longitude: +param.longitude, // 经度，浮点数，范围为180 ~ -180
          scale: 18,
        });
      }),
    );
  },
  /**
   * 判断是否微信小程序环境
   */
  async inWxMinipro() {
    const promiseKey = 'IN_WX_MINIPRO';
    if (this[promiseKey]) {
      return this[promiseKey];
    }
    try {
      const wx = await configWeixin();
      const promise = await new Promise((resolve) => {
        wx.miniProgram.getEnv((res) => {
          resolve(res.miniprogram);
        });
      });
      this[promiseKey] = promise;
      return promise;
    } catch (e) {
      delete this[promiseKey];
      return false;
    }
  },

  commonshare({
    title, desc, link, imgUrl, success, cancel,
  }) {
    if (!env.isWeixin) {
      return;
    }

    // link.replace(/\/\/[a-z\.]+/, `//${authStore.domain}`);

    this.showAllNonBaseMenuItem();
    ['onMenuShareAppMessage', 'onMenuShareTimeline'].forEach((method) => {
      this[method]({
        title,
        desc,
        link,
        imgUrl,
        success,
        cancel,
      });
    });
  },
  closeWindow: bindWXMethod('closeWindow'),
  onMenuShareTimeline: bindWXMethod('onMenuShareTimeline'),
  onMenuShareAppMessage: bindWXMethod('onMenuShareAppMessage'),
  onMenuShareQQ: bindWXMethod('onMenuShareQQ'),
  onMenuShareWeibo: bindWXMethod('onMenuShareWeibo'),
  onMenuShareQZone: bindWXMethod('onMenuShareQZone'),
  hideMenuItems: bindWXMethod('hideMenuItems'),
  showMenuItems: bindWXMethod('showMenuItems'),
  hideAllNonBaseMenuItem: bindWXMethod('hideAllNonBaseMenuItem'),
  showAllNonBaseMenuItem: bindWXMethod('showAllNonBaseMenuItem'),

  redirectTo(url) {
    return handleMiniProRoute('redirectTo', url);
  },
  switchTab(url) {
    return handleMiniProRoute('switchTab', url);
  },
  reLaunch(url) {
    return handleMiniProRoute('reLaunch', url);
  },
  navigateBack(delta = 1) {
    try {
      return new Promise((resolve, reject) => {
        configWeixin().then((wx) => {
          wx.miniProgram.getEnv((res) => {
            if (res.miniprogram) {
              wx.miniProgram.navigateBack({
                delta,
                success: resolve,
                fail: reject,
              });
            } else {
              reject();
            }
          });
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  },
  postMessage(shareObj) {
    try {
      return new Promise((resolve, reject) => {
        configWeixin().then((wx) => {
          wx.miniProgram.getEnv((res) => {
            if (res.miniprogram) {
              wx.miniProgram.postMessage({ data: shareObj });
              resolve();
            } else {
              reject();
            }
          });
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  },

  async navigateTo(url) {
    if (!url) return;
    const isWxMp = await this.inWxMinipro();
    if (url.startsWith('http')) {
      // 第三方链接
      if (isWxMp) {
        const tar = env.isWxHitchMp
          ? `${env.wxHitchMpPathPrefix}/main/pages/MyWebView/MyWebView?url=${encodeURIComponent(url)}`
          : `/pages/web-view/web-view?url=${encodeURIComponent(url)}`;
        handleMiniProRoute('navigateTo', tar);
      } else {
        window.location.href = url;
      }
    } else if (url.startsWith('/')) {
      // 小程序页面
      handleMiniProRoute('navigateTo', url);
    } else if (process.env.VUE_APP_ENV !== 'pro') {
      toast.show('非有效链接，请检查');
    }
  },
};

export default wechat;
